<template>
  <layout>
    <page-header :actions="actions()" :header="$t('general.currencies')" />
    <div class="content">
      <b-row>
        <b-col lg="12" xl="10">
          <admin-table
            ref="table"
            v-bind="tableProps"
            :sort-legacy-format="false"
            :on-edit-item="onEditItem"
            @api-result="dataLoaded"
          >
            <template #rate="{ item }">
              <span :class="{ 'text-muted': !item.rate }">
                {{ item.rate || 'N/A' }}
              </span>
            </template>
          </admin-table>
        </b-col>
      </b-row>
    </div>

    <CurrencyFormModal :id="editId" :visible.sync="showForm" @saved="saved" />
  </layout>
</template>


<script>
import { AdminTable } from 'stylemix-vue-admin'
import Api from './Api'
import CurrencyFormModal from './CurrencyFormModal.vue'

const resourceBase = 'currencies'

export default {
  name: 'CurrenciesIndex',

  components: {
    AdminTable,
    CurrencyFormModal,
  },

  data() {
    return {
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new Api()
        },
        columns: [
          {
            key: 'name',
            label: this.$t('currencies.attributes.name.label'),
            sortable: true,
          },
          {
            key: 'code',
            label: this.$t('currencies.attributes.code.label'),
            sortable: true,
          },
          {
            key: 'symbol',
            label: this.$t('currencies.attributes.symbol.label'),
          },
          {
            key: 'rate',
            label: this.$t('currencies.attributes.rate.label'),
            sortable: true,
          },
        ],

        rowActions: (item) => {
          const actions = []
          if (!this.nonDeletable.includes(item.code)) {
            actions.push({
              variant: 'success',
              label: this.$t('currencies.buttons.default'),
              handler: () => {
                this.setDefault(item)
              },
            })
          }

          actions.push('edit')

          if (!this.nonDeletable.includes(item.code)) {
            actions.push('delete')
          }

          return actions
        },

        bulkActions() {
          return []
        },

        searchFields: [],
      },

      showForm: false,
      editId: null,
      nonDeletable: [],
    }
  },

  methods: {
    actions() {
      return [
        {
          id: 'add',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.showForm = true
            this.editId = null
          },
        },
      ]
    },

    saved() {
      this.editId = null
      this.showForm = false
      // this.$refs.table.refresh()
      location.reload()
    },

    dataLoaded(result) {
      this.nonDeletable = result['non_deletable']
    },

    async setDefault(item) {
      if (
        !(
          await this.$alert.question(
            this.$t('currencies.messages.confirm_set_default')
          )
        ).value
      ) {
        return
      }

      let promise = new Api().setDefault(item.id).then(result => {
        location.reload()
      })
      this.$uiBlocker(promise, this.$refs.form)
    },

    onEditItem({ id }) {
      this.editId = id
      this.showForm = true
    },
  },
}
</script>
